import AudienceUpdateFrequencyView from './AudienceUpdateFrequency.View';

const AudienceUpdateFrequency = () => <AudienceUpdateFrequencyView />;

export default AudienceUpdateFrequency;
